export default class BarAccordion {
    constructor() {
        const _this = this;
        document.querySelectorAll('.bar i.toggle').forEach((el) => {
            let bar = el.parentElement;
            bar.addEventListener('click', () => {
                _this.toggle(el);
            });
        });
    }

    toggle(el) {
        let body = el.closest('.opener').nextElementSibling;
        if (body) {
            $(body).animate({ height: 'toggle' }, 200, () => {
                el.classList.toggle('icon-right-circle');
                el.classList.toggle('icon-down-circle');
                const ev = new CustomEvent('onBarAccordionToggle',{ detail :
                    {
                        expanded: el.classList.contains('icon-down-circle')
                    }
                });
                document.dispatchEvent(ev);

            });
        }
    }
}
